import AdminToolInfo from "../../components/admin-tool-info";

const AdminTool: React.FC = () => {

	return (
		<AdminToolInfo />
	);
};
export default AdminTool;
